import type { Metatype } from '@jet/environment/util/metatype';
import { makeMetatype } from '@jet/environment/util/metatype';
import type { Prebootstrap } from '@jet-app/music-classical/bootstrap';
import type { Dispatcher } from '@jet-app/music-classical/base/dispatcher';
import type { Logger, LoggerFactory } from '@amp/web-apps-logger';
import { RouteUrlIntentController } from '@jet-app/music-classical/intents/route-url';

export const LoggerMetaType = makeMetatype('LocalLogger') as Metatype<Logger>;

export const createPreBootstrap = (
    loggerFactory: LoggerFactory,
): Prebootstrap => {
    return {
        addIntents(intentDispatcher: Dispatcher) {
            // If we need to override any controllers, do it here
            // intentDispatcher.register(SearchSuggestionsIntentController);
            intentDispatcher.register(RouteUrlIntentController);
        },
        modifyObjectGraph(objectGraph) {
            const logger = loggerFactory.loggerFor('music-classical-client-js');
            return objectGraph.adding(LoggerMetaType, logger);
        },
    };
};
